import TabsPage from 'navigation/pages/TabsPage';
class Legals extends TabsPage {
    static pageName = 'Legals';
    initialized() {
        super.initialized();
    }
}
export default Legals;
